import React, { useContext, useState, useEffect } from 'react';
import { Popover, Button } from 'antd';
import { QuestionCircleTwoTone } from '@ant-design/icons';
import Duo from './Bilder/MCII_duo.png';
import Quadro from './Bilder/MCII_quadro.png';
import VersionDropdown from './VersionDropdown';
import PremiumChanger from './PremiumChanger';
import QuadChanger from './QuadChanger';
import ValueContext from './Context';
import './Menu.css';

export default function Menu(props) {
  const { locale, getText } = useContext(ValueContext);
  const [text, settext] = useState(getText());

  useEffect(() => {
    settext(getText());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [locale]);

  const QuadContent = (
    <div className='PopOverContent'>
      {text.Menu.QuadContent}
      <img className='MultDuo' src={Duo} alt='MultiControl II duo' />
      <img className='MultQuad' src={Quadro} alt='MultiControl II quadro' />
    </div>
  );
  const VersionContent = <div className='PopOverContent'>{text.Menu.VersionContent}</div>;
  const PremiumContent = <div className='PopOverContent'>{text.Menu.PremiumContent}</div>;
  return (
    <div className='Menu'>
      <span className='QuadTitle'>
        {text.Menu.QuadTitle}
        <Popover
          placement='right'
          overlayClassName='QuadPopOverContent'
          title={<span className='PopOverTitle'>{text.Menu.QuadPopOverTitle}</span>}
          content={QuadContent}>
          <QuestionCircleTwoTone
            twoToneColor='#969696'
            style={{ fontSize: '1.5em', marginLeft: '15px' }}
          />
        </Popover>
      </span>
      <div className='QuadChanger'>
        <QuadChanger />
      </div>
      <span className='VersionTitle'>
        {text.Menu.VersionTitle}
        <Popover
          placement='right'
          title={<span className='PopOverTitle'>{text.Menu.VersionPopOverTitle}</span>}
          content={VersionContent}>
          <QuestionCircleTwoTone
            twoToneColor='#969696'
            style={{ fontSize: '1.5em', marginLeft: '15px' }}
          />
        </Popover>
      </span>
      <div className='VersionDropdown'>
        <VersionDropdown />
      </div>
      <span className='PremiumTitle'>
        {text.Menu.PremiumTitle}
        <Popover
          placement='right'
          title={<span className='PopOverTitle'>{text.Menu.PremiumPopOverTitle}</span>}
          content={PremiumContent}>
          <QuestionCircleTwoTone
            twoToneColor='#969696'
            style={{ fontSize: '1.5em', marginLeft: '15px' }}
          />
        </Popover>
      </span>
      <div className='PremiumChanger'>
        <PremiumChanger />
      </div>
      <div className='MenuButton'>
        <Button onClick={() => props.onclick()} type="primary">{text.Menu.OKButton}</Button>
      </div>
    </div>
  );
}
